const initMainSearchCustom = () => {

  const form =
    document.getElementById('SearchPageForm');

  const input =
    form?.querySelector('input[name="q"]');

  if (!form || !input) return;

  if (form.dataset.mainSearchInitialized === 'true') return;

  form.dataset.mainSearchInitialized = 'true';

  const isIos =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (
      navigator.platform === 'MacIntel' &&
      navigator.maxTouchPoints > 1
    );

  if (isIos) {
    input.addEventListener(
      'focus',
      () => {
        const scrollY = window.scrollY;

        document.body.classList.add('main-search-ios-input-focused');

        requestAnimationFrame(() => {
          window.scrollTo(0, scrollY);

          requestAnimationFrame(() => {
            window.scrollTo(0, scrollY);
          });
        });
      },
      { passive: true }
    );

    input.addEventListener(
      'blur',
      () => {
        document.body.classList.remove('main-search-ios-input-focused');
      },
      { passive: true }
    );
  }

  let controller = null;
  let timeout = null;
  let requestId = 0;
  let filterRebuildFrame = null;
  let filterRebuildTimer = null;
  let filterApplyFrame = null;
  let drawerFilterRefreshTimer = null;
  const cardVariantMapCache = new WeakMap();



const initMainSearchFilterBar = () => {
  const activeProductsTab =
  document.querySelector('.search__tab[data-id="products"][aria-hidden="false"]') ||
  document.querySelector('.search__tab[data-id="products"]:not([aria-hidden="true"])');

const grid =
  activeProductsTab?.querySelector('#ShopProductsGrid') ||
  document.querySelector('#ShopProductsGrid');
  const selectedTab = document.querySelector('.search__tab-name.selected')?.dataset.id;
  const resetButtons = Array.from(document.querySelectorAll('[data-fc-clear-all]'));

  if (window.mainSearchFilterAbort) {
    window.mainSearchFilterAbort.abort();
  }

  window.mainSearchFilterAbort = new AbortController();

  const signal = window.mainSearchFilterAbort.signal;

  document.addEventListener(
    'pointerdown',
    event => {
      const control = event.target.closest(
        '.fc-filter-option, [data-fc-sort-option], .fc-active-filter-clear, .fc-filter-actions [data-fc-clear-all]'
      );

      if (!control) return;

      control.classList.add('is-pressing');

      window.setTimeout(() => {
        control.classList.remove('is-pressing');
      }, 160);
    },
    { signal, passive: true }
  );

    window.mainSearchActiveFilters =
window.mainSearchActiveFilters || {
  search: '',

  category: '',

  genre: '',
  nsfw: '',

  department: '',
  apparel: '',
  fit: '',
  aesthetic: '',

  services: '',

  color: [],
  tone: [],
  size: '',
  collection: '',

  sort: ''
};

  const activeFilters = window.mainSearchActiveFilters;

  const currentSearchQuery =
    input.value.trim();

  activeFilters.search =
    currentSearchQuery && currentSearchQuery !== '*'
      ? currentSearchQuery
      : '';


const bindSearchTabListeners = () => {
  document.querySelectorAll('[data-tabs-name]').forEach(tab => {
    if (tab.dataset.mainSearchFilterTabBound === 'true') return;

    tab.dataset.mainSearchFilterTabBound = 'true';

    tab.addEventListener('click', () => {
      setTimeout(initMainSearchFilterBar, 80);
    });
  });
};

bindSearchTabListeners();

const isProductsTab =
  !selectedTab ||
  selectedTab === 'products';

if (!isProductsTab) {
  return;
}

if (!grid) {
  return;
}

      const getPrefetchCache = () => {
    let cache = document.getElementById('MainSearchPrefetchCache');

    if (!cache) {
      cache = document.createElement('div');
      cache.id = 'MainSearchPrefetchCache';
      cache.hidden = true;
      cache.style.display = 'none';

      grid.after(cache);
    }

    if (
      cache.dataset.mainSearchPreloadedCache === 'true' &&
      cache.querySelector('.shop__grid-item')
    ) {
      grid.dataset.mainSearchPrefetched = 'true';
    }

    return cache;
  };

  const getProductKey = item => {
    if (!item) return '';

    if (item.dataset.fcProductKey) {
      return item.dataset.fcProductKey;
    }

    const productLinks =
      Array.from(item.querySelectorAll('a[href*="/products/"]'));

    const productHref =
      productLinks
        .map(link => link.getAttribute('href') || '')
        .find(href => href.includes('/products/')) || '';

    const productMatch =
      productHref.match(/\/products\/([^/?#]+)/);

    const key =
      productMatch?.[1]
        ? productMatch[1].trim().toLowerCase()
        : (
            item.dataset.title ||
            item.querySelector('.product-card__title')?.textContent ||
            item.textContent ||
            ''
          )
            .trim()
            .replace(/\s+/g, ' ')
            .toLowerCase();

    item.dataset.fcProductKey = key;

    return key;
  };

  const getItems = () => [
    ...Array.from(grid.querySelectorAll('.shop__grid-item')),
    ...Array.from(getPrefetchCache().querySelectorAll('.shop__grid-item'))
  ];

  const getVisibleDedupeKey = item =>
    (
      item?.dataset.title ||
      item?.querySelector('.product-card__title')?.textContent ||
      getProductKey(item) ||
      ''
    )
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

  const getFilterSourceItems = () => {
    const sourceItems = Array.from(
      document.querySelectorAll('[data-fc-filter-source]')
    );

    return sourceItems.length ? sourceItems : getItems();
  };

  const getCards = () =>
    getItems()
      .map(item => item.querySelector('product-card'))
      .filter(Boolean);

      const getTitle = item =>
  (item.dataset.title || '').trim().toLowerCase();

  const getTags = item =>
    (item.dataset.tags || '')
      .split(',')
      .map(tag => tag.trim().toLowerCase())
      .filter(Boolean);

  const normalizeFilterValue = value =>
  (value || '')
    .toString()
    .trim()
    .toLowerCase();

const getProductType = item =>
  normalizeFilterValue(
    item.dataset.fcCategory || item.dataset.productType
  );

const splitMetafield = value =>
  (value || '')
    .toString()
    .split(',')
    .map(item => item.trim().toLowerCase())
    .filter(Boolean);

let genreSubtypeFilterCache = null;

const normalizeGenreConfigValue = value =>
  (value || '')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/\s+/g, ' ');

const getGenreSubtypeFilters = () => {
  if (genreSubtypeFilterCache) {
    return genreSubtypeFilterCache;
  }

  const script = document.querySelector('[data-genre-filter-config]');

  if (!script) {
    genreSubtypeFilterCache = [];
    return genreSubtypeFilterCache;
  }

  try {
    const parsed = JSON.parse(script.textContent || '[]');

    genreSubtypeFilterCache = Array.isArray(parsed)
      ? parsed
          .map(item => ({
            key: normalizeGenreConfigValue(item.key || ''),
            label: item.label || formatFilterLabel(item.key || ''),
            genre: normalizeGenreConfigValue(item.genre || item.key || '')
          }))
          .filter(item => item.key && item.genre)
      : [];

    return genreSubtypeFilterCache;
  } catch (error) {
    console.error('[Main Search] Could not parse genre-filter-config.', error);
    genreSubtypeFilterCache = [];
    return genreSubtypeFilterCache;
  }
};

const getGenreSubtypeKeys = () =>
  getGenreSubtypeFilters().map(item => item.key);

const getGenreSubtypeByGenre = genre =>
  getGenreSubtypeFilters().find(item =>
    item.genre === normalizeGenreConfigValue(genre)
  );

getGenreSubtypeKeys().forEach(key => {
  if (!(key in activeFilters)) {
    activeFilters[key] = '';
  }
});

const getSubtypeValues = (item, key) => {
  if (!item || !key) return [];

  const normalizedKey = normalizeGenreConfigValue(key);
  const camelKey = normalizedKey.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
  const pascalKey = camelKey.charAt(0).toUpperCase() + camelKey.slice(1);

  return splitMetafield(
    item.dataset[camelKey] ||
    item.dataset[`fc${pascalKey}`] ||
    item.dataset[`filter${pascalKey}`] ||
    ''
  );
};

const hasSubtypeValues = (item, key) =>
  getSubtypeValues(item, key).length > 0;

const getFcGenre = item =>
  splitMetafield(
    item.dataset.fcGenre ||
    item.dataset.genre ||
    ''
  );

const getFcNsfw = item =>
  splitMetafield(item.dataset.fcNsfw);

const getFcApparel = item =>
  splitMetafield(item.dataset.fcApparel);

const getFcServices = item =>
  splitMetafield(item.dataset.fcServices);

const getFcDepartment = item =>
  splitMetafield(item.dataset.fcDepartment);

const getFcFit = item =>
  splitMetafield(item.dataset.fcFit);

const getFcAesthetic = item =>
  splitMetafield(item.dataset.fcAesthetic);

const getFcColorFamily = item =>
  splitMetafield(item.dataset.fcColorFamily);

const getFcColorTone = item =>
  splitMetafield(item.dataset.fcColorTone);

const getFcColorTonePairs = item =>
  (item.dataset.fcColorTonePairs || '')
    .toString()
    .split('||')
    .map(pair => {
      const parts = pair.split('::');

      return {
        family: normalizeFilterValue(parts[0] || ''),
        tone: normalizeFilterValue(parts[1] || '')
      };
    })
    .filter(pair => pair.family && pair.tone);

const multiSelectFilterKeys = ['color', 'tone'];

const isMultiSelectFilter = key =>
  multiSelectFilterKeys.includes(key);

const getActiveFilterValues = key => {
  const value = activeFilters[key];

  if (Array.isArray(value)) {
    return value.map(normalizeFilterValue).filter(Boolean);
  }

  if (value) {
    return [normalizeFilterValue(value)];
  }

  return [];
};

const isActiveFilterValue = (key, value) =>
  getActiveFilterValues(key).includes(normalizeFilterValue(value));

const toggleActiveFilterValue = (key, value) => {
  const normalizedValue = normalizeFilterValue(value);

  if (!isMultiSelectFilter(key)) {
    activeFilters[key] =
      normalizeFilterValue(activeFilters[key]) === normalizedValue ? '' : normalizedValue;

    return;
  }

  const values = getActiveFilterValues(key);

  activeFilters[key] = values.includes(normalizedValue)
    ? values.filter(item => item !== normalizedValue)
    : [...values, normalizedValue];
};

const clearActiveFilterValue = (key, value = '') => {
  if (!isMultiSelectFilter(key)) {
    activeFilters[key] = '';
    return;
  }

  const normalizedValue = normalizeFilterValue(value);

  activeFilters[key] = normalizedValue
    ? getActiveFilterValues(key).filter(item => item !== normalizedValue)
    : [];
};

const getContentTypes = item => {
  const contentTypes = new Set(getFcGenre(item));

  getGenreSubtypeFilters().forEach(filter => {
    if (hasSubtypeValues(item, filter.key)) {
      contentTypes.add(filter.genre);
    }
  });

  if (getFcNsfw(item).length > 0) {
    contentTypes.add('nsfw');
  }

  return [...contentTypes];
};

const getFcGenres = item =>
  getContentTypes(item);

const itemHasGenre = (item, genre) => {
  const normalizedGenre =
    normalizeGenreConfigValue(genre);

  if (!normalizedGenre) return true;

  const directGenres =
    getFcGenre(item).map(value => normalizeGenreConfigValue(value));

  if (directGenres.includes(normalizedGenre)) {
    return true;
  }

  const subtype =
    getGenreSubtypeByGenre(normalizedGenre);

  if (subtype && hasSubtypeValues(item, subtype.key)) {
    return true;
  }

  return getFcGenres(item)
    .map(value => normalizeGenreConfigValue(value))
    .includes(normalizedGenre);
};

const getOptions = item =>
  (item.dataset.options || '')
    .split(',')
    .map(option => option.trim())
    .filter(Boolean);

  const getPrice = item =>
    parseFloat(item.dataset.price || '0') || 0;

  const getDate = item =>
    parseInt(item.dataset.date || '0', 10) || 0;

    const hasActiveProductFilter = () =>
  Boolean(
    activeFilters.category ||

    activeFilters.genre ||
    getGenreSubtypeKeys().some(key => Boolean(activeFilters[key])) ||
    activeFilters.nsfw ||

    activeFilters.department ||
    activeFilters.apparel ||
    activeFilters.fit ||
    activeFilters.aesthetic ||

    activeFilters.services ||

    getActiveFilterValues('color').length ||
    getActiveFilterValues('tone').length ||
    activeFilters.size ||
    activeFilters.collection
  );

  
  const colorMap = {
    black: '#000000',
    white: '#ffffff',
    gray: '#808080',
    grey: '#808080',
    charcoal: '#36454f',
    navy: '#1f2a44',
    blue: '#2f6db5',
    royal: '#4169e1',
    red: '#c62828',
    pink: '#f5a6c8',
    purple: '#7b3fb3',
    lavender: '#c8a2c8',
    green: '#4f7f52',
    sage: '#9caf88',
    mint: '#98ff98',
    yellow: '#f6d44b',
    gold: '#d4af37',
    orange: '#f28c28',
    brown: '#8b5a2b',
    tan: '#d2b48c',
    beige: '#d8c3a5',
    cream: '#f5f0dc',
    ivory: '#fffff0',
    natural: '#e8dcc2',
    sand: '#c2b280',
    aqua: '#7fdbda',
    turquoise: '#40e0d0'
  };

  const getColorValue = colorName => {
    const normalized = colorName.toLowerCase();

    const match = Object.keys(colorMap).find(key =>
      normalized.includes(key)
    );

    return match ? colorMap[match] : '#e5e5e5';
  };

  const isColorToneSelectionTemporarilyUnavailable = (key, value) => {
  const normalizedValue = normalizeFilterValue(value);

  if (key !== 'color' && key !== 'tone') return false;
  if (!isActiveFilterValue(key, normalizedValue)) return false;

  const selectedColors =
    key === 'color'
      ? [normalizedValue]
      : getActiveFilterValues('color');

  const selectedTones =
    key === 'tone'
      ? [normalizedValue]
      : getActiveFilterValues('tone');

  if (!selectedColors.length || !selectedTones.length) return false;

  const itemMatchesNonColorToneScope = item => {
    if (activeFilters.category && getProductType(item) !== activeFilters.category) return false;
    if (activeFilters.genre && !itemHasGenre(item, activeFilters.genre)) return false;

    for (const filter of getGenreSubtypeFilters()) {
      if (
        activeFilters[filter.key] &&
        !getSubtypeValues(item, filter.key).includes(activeFilters[filter.key])
      ) {
        return false;
      }
    }

    if (activeFilters.nsfw && !getFcNsfw(item).includes(activeFilters.nsfw)) return false;
    if (activeFilters.department && !getFcDepartment(item).includes(activeFilters.department)) return false;
    if (activeFilters.apparel && !getFcApparel(item).includes(activeFilters.apparel)) return false;
    if (activeFilters.fit && !getFcFit(item).includes(activeFilters.fit)) return false;
    if (activeFilters.aesthetic && !getFcAesthetic(item).includes(activeFilters.aesthetic)) return false;
    if (activeFilters.services && !getFcServices(item).includes(activeFilters.services)) return false;
    if (activeFilters.size && !getOptions(item).map(option => option.toLowerCase()).includes(activeFilters.size)) return false;
    if (activeFilters.collection && !getTags(item).includes(activeFilters.collection)) return false;

    return true;
  };

  return !getFilterSourceItems().some(item => {
    if (!itemMatchesNonColorToneScope(item)) return false;

    const pairs = getFcColorTonePairs(item);

    if (pairs.length) {
      return pairs.some(pair =>
        selectedColors.includes(pair.family) &&
        selectedTones.includes(pair.tone)
      );
    }

    return (
      selectedColors.some(color => getFcColorFamily(item).includes(color)) &&
      selectedTones.some(tone => getFcColorTone(item).includes(tone))
    );
  });
};

  const knownSizes = [
    'xxs',
    'xs',
    's',
    'm',
    'l',
    'xl',
    '2xl',
    '3xl',
    '4xl',
    '5xl',
    '6xl'
  ];

  const buildDynamicFilter = (key, values) => {
  const menus = document.querySelectorAll(`[data-fc-options="${key}"]`);

  if (!menus.length) return;

  const normalizedValues = values
    .map(value => {
      if (typeof value === 'object') {
        return {
          value: normalizeFilterValue(value.value),
          label: value.label
        };
      }

      return {
        value: value.toLowerCase(),
        label: value
      };
    })
    .filter(item => item.value && item.label);

  const uniqueMap = new Map();

  normalizedValues.forEach(item => {
    if (!uniqueMap.has(item.value)) {
      uniqueMap.set(item.value, item.label);
    }
  });

  const uniqueValues = [...uniqueMap.entries()]
    .map(([value, label]) => ({ value, label }));

  if (key === 'size') {
    uniqueValues.sort((a, b) =>
      knownSizes.indexOf(a.value.toLowerCase()) -
      knownSizes.indexOf(b.value.toLowerCase())
    );
    } else if (key === 'color') {
    uniqueValues.sort((a, b) =>
      colorFamilyOrder.indexOf(a.label) -
      colorFamilyOrder.indexOf(b.label)
    );
  } else if (key === 'tone') {
    uniqueValues.sort((a, b) =>
      toneOrder.indexOf(a.label) -
      toneOrder.indexOf(b.label)
    );
  } else {
    uniqueValues.sort((a, b) =>
      a.label.localeCompare(b.label, undefined, { numeric: true })
    );
  }

  menus.forEach(menu => {
    const group = menu.closest('[data-fc-filter-group]');

    menu.innerHTML = '';

    if (group) {
      group.hidden = uniqueValues.length === 0;
    }

    let currentColorGroup = '';

const getColorGroup = label => {

  if ([
    'White',
    'Black',
    'Light Grey',
    'Grey',
    'Dark Grey',
    'Cream',
    'Tan',
    'Brown'
  ].includes(label)) {
    return 'Neutrals';
  }

  if ([
    'Light Red',
    'Red',
    'Dark Red',

    'Light Pink',
    'Pink',
    'Dark Pink',

    'Light Orange',
    'Orange',
    'Dark Orange',

    'Yellow'
  ].includes(label)) {
    return 'Warms';
  }

  if ([
    'Light Green',
    'Green',
    'Dark Green',

    'Turquoise',

    'Light Blue',
    'Blue',
    'Dark Blue',

    'Light Purple',
    'Purple',
    'Dark Purple'
  ].includes(label)) {
    return 'Cools';
  }

  if ([
    'Camo',
    'Multi',
    'Other'
  ].includes(label)) {
    return 'Mixes';
  }

  return '';
};

    uniqueValues.forEach(item => {

  if (key === 'color') {
    const group = getColorGroup(item.label);

    if (group && group !== currentColorGroup) {
      currentColorGroup = group;

      const heading = document.createElement('div');
      heading.className = 'fc-color-group-heading';
      heading.textContent = group;

      menu.appendChild(heading);
    }
  }

  const button = document.createElement('button');

      button.type = 'button';
      button.className = 'pill pill--small pill--outline fc-filter-option';
      button.dataset.fcFilter = key;
      button.dataset.fcValue = item.value;

      if (isActiveFilterValue(key, item.value)) {
  button.classList.add('selected');

  if (isColorToneSelectionTemporarilyUnavailable(key, item.value)) {
    button.classList.add('fc-temporarily-unavailable');
  }
}

            if (key === 'color') {
        const colorHex =
          colorFamilyHex[item.label] ||
          colorFamilyHex[formatFilterLabel(item.value)] ||
          '#e5e5e5';

        button.classList.add('fc-color-pill');

        button.style.setProperty('--fc-color-swatch', colorHex);
        button.style.setProperty('--fc-color-swatch-border', darkenHex(colorHex, 0.28));
        button.style.removeProperty('background-color');
        button.style.removeProperty('border-color');
        button.style.removeProperty('color');
              }

      if (key === 'color') {
        button.innerHTML = `
          <span class="fc-filter-swatch" aria-hidden="true"></span>
          <span class="pill__label">${item.label}</span>
        `;
      } else {
        button.innerHTML = `<span class="pill__label">${item.label}</span>`;
      }

      menu.appendChild(button);

    });
  });
};

  const getAuroraSwatches = () => {
  const script = document.getElementById('AuroraSearchSwatchMap');

  if (!script) return {};

  try {
    return JSON.parse(script.textContent || '{}');
  } catch (error) {
    return {};
  }
};

const hexToRgb = hex => {
  const clean = hex.replace('#', '').trim();

  if (clean.length !== 6) return null;

  const value = parseInt(clean, 16);

  return {
    r: (value >> 16) & 255,
    g: (value >> 8) & 255,
    b: value & 255
  };
};

const rgbToHsl = ({ r, g, b }) => {
  r /= 255;
  g /= 255;
  b /= 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const lightness = (max + min) / 2;

  let hue = 0;
  let saturation = 0;

  if (max !== min) {
    const delta = max - min;

    saturation =
      lightness > 0.5
        ? delta / (2 - max - min)
        : delta / (max + min);

    if (max === r) {
      hue = (g - b) / delta + (g < b ? 6 : 0);
    } else if (max === g) {
      hue = (b - r) / delta + 2;
    } else {
      hue = (r - g) / delta + 4;
    }

    hue *= 60;
  }

  return {
    h: hue,
    s: saturation * 100,
    l: lightness * 100
  };
};


const colorFamilyHex = {
  'Black': '#0A0A0A',
  'White': '#FFFFFF',

  'Dark Grey': '#3A3A3A',
  'Grey': '#808080',
  'Light Grey': '#D9D9D9',

  'Brown': '#5E3D09',
  'Tan': '#D2B48C',
  'Cream': '#DEDACA',

  'Dark Red': '#8B0000',
  'Red': '#E21919',
  'Light Red': '#F4A3A3',

  'Dark Pink': '#B03060',
  'Pink': '#FF6BB3',
  'Light Pink': '#F8C8DC',

  'Dark Orange': '#BA5400',
  'Orange': '#EF8A21',
  'Light Orange': '#FDBA74',

  'Yellow': '#FFD52E',

  'Dark Green': '#355E3B',
  'Green': '#4CAF50',
  'Light Green': '#93C47D',

  'Turquoise': '#40E0D0',

  'Dark Blue': '#062263',
  'Blue': '#157CC9',
  'Light Blue': '#9FC5E8',

  'Dark Purple': '#300A52',
  'Purple': '#801FDB',
  'Light Purple': '#C9A0DC',

  'Camo': '#4B5320',
  'Multi': '#C9A0DC',
  'Other': '#E5E5E5'
};

const darkenHex = (hex, amount = 0.28) => {
  const value = hex.replace('#', '');

  const r = parseInt(value.substring(0, 2), 16);
  const g = parseInt(value.substring(2, 4), 16);
  const b = parseInt(value.substring(4, 6), 16);

  const darken = channel =>
    Math.max(0, Math.floor(channel * (1 - amount)));

  return `rgb(${darken(r)}, ${darken(g)}, ${darken(b)})`;
};

const darkColorFamilies = [
  'Black',
  'Dark Grey',
  'Brown',
  'Dark Red',
  'Red',
  'Dark Pink',
  'Dark Orange',
  'Orange',
  'Dark Green',
  'Green',
  'Camo',
  'Dark Blue',
  'Blue',
  'Dark Purple',
  'Purple'
];

const colorFamilyOrder = [
  'White',
  'Black',
  
  'Light Grey',
  'Grey',
  'Dark Grey',

  'Cream',
  'Tan',
  'Brown',

  'Light Red',
  'Red',
  'Dark Red',

  'Light Pink',
  'Pink',
  'Dark Pink',

  'Light Orange',
  'Orange',
  'Dark Orange',

  'Yellow',

  'Light Green',
  'Green',
  'Dark Green',

  'Turquoise',

  'Light Blue',
  'Blue',
  'Dark Blue',

  'Light Purple',
  'Purple',
  'Dark Purple',

  'Camo',
  'Multi',
  'Other'
];

const toneOrder = [
  'Pastel',
  'Muted',
  'Classic',
  'Vibrant',
  'Deep'
];

const formatFilterLabel = value =>
  value
    .toString()
    .replace(/^collection-/, '')
    .replace(/^nsfw$/, 'NSFW')
    .replace(/-/g, ' ')
    .split(/\s+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

    const ensureToneFilterRows = () => {
  document
    .querySelectorAll('[data-fc-filter-group="color"]')
    .forEach(colorGroup => {
      const parent = colorGroup.parentElement;

      if (!parent) return;
      if (parent.querySelector('[data-fc-filter-group="tone"]')) return;

      const toneGroup = colorGroup.cloneNode(true);

      toneGroup.setAttribute('data-fc-filter-group', 'tone');

      toneGroup
        .querySelectorAll('[data-fc-options="color"]')
        .forEach(menu => {
          menu.setAttribute('data-fc-options', 'tone');
          menu.innerHTML = '';
        });

      const label =
        toneGroup.querySelector('.sidebar-filters__filter-name') ||
        toneGroup.querySelector('.collapsible-row-list-item__title') ||
        toneGroup.querySelector('[data-sidebar-filter-title]') ||
        Array.from(toneGroup.querySelectorAll('*')).find(el =>
          el.children.length === 0 &&
          el.textContent.trim().toLowerCase() === 'color'
        );

      if (label) {
        label.textContent = 'Color Tone';
      }

      parent.insertBefore(toneGroup, colorGroup.nextSibling);
    });
};

const buildProductFilters = () => {
  ensureToneFilterRows();

  const categories = new Set();

  const genres = new Set();

  const genreSubtypeValueSets = new Map();

  getGenreSubtypeFilters().forEach(filter => {
    genreSubtypeValueSets.set(filter.key, new Set());
  });

  const nsfw = new Set();

  const departments = new Set();
  const apparel = new Set();
  const fit = new Set();
  const aesthetic = new Set();

  const services = new Set();

  const colors = new Set();
  const tones = new Set();
  const sizes = [];
  const collections = new Set();

  const sourceItems = getFilterSourceItems();
const selectedColors = getActiveFilterValues('color');
const selectedTones = getActiveFilterValues('tone');

const itemMatchesOptionScope = (item, ignoredKey = '') => {
  if (
  ignoredKey !== 'category' &&
  activeFilters.category &&
  getProductType(item) !== activeFilters.category
) return false;

  if (
    activeFilters.genre &&
    !itemHasGenre(item, activeFilters.genre)
  ) return false;

  for (const filter of getGenreSubtypeFilters()) {
    if (
      ignoredKey !== filter.key &&
      activeFilters[filter.key] &&
      !getSubtypeValues(item, filter.key).includes(activeFilters[filter.key])
    ) {
      return false;
    }
  }

  if (
    activeFilters.nsfw &&
    !getFcNsfw(item).includes(activeFilters.nsfw)
  ) return false;

  if (
    activeFilters.department &&
    !getFcDepartment(item).includes(activeFilters.department)
  ) return false;

  if (
    activeFilters.apparel &&
    !getFcApparel(item).includes(activeFilters.apparel)
  ) return false;

  if (
    activeFilters.fit &&
    !getFcFit(item).includes(activeFilters.fit)
  ) return false;

  if (
    activeFilters.aesthetic &&
    !getFcAesthetic(item).includes(activeFilters.aesthetic)
  ) return false;

  if (
    activeFilters.services &&
    !getFcServices(item).includes(activeFilters.services)
  ) return false;

  if (
    activeFilters.size &&
    !getOptions(item).map(option => option.toLowerCase()).includes(activeFilters.size)
  ) return false;

  if (
    activeFilters.collection &&
    !getTags(item).includes(activeFilters.collection)
  ) return false;

  if (
    ignoredKey !== 'color' &&
    selectedColors.length &&
    !selectedColors.some(color => getFcColorFamily(item).includes(color))
  ) return false;

  if (
    ignoredKey !== 'tone' &&
    selectedTones.length &&
    !selectedTones.some(tone => getFcColorTone(item).includes(tone))
  ) return false;

  return true;
};

  const rebuildTonesFromSelectedColors = () => {
    tones.clear();

    getItems().forEach(realItem => {
      const card = realItem.querySelector('product-card');
      const variants = card ? getCardVariantMap(card) : [];

      variants.forEach(variant => {
        const family = getVariantFamily(variant);
        const tone = getVariantTone(variant);

        if (
          family &&
          tone &&
          selectedColors.includes(family)
        ) {
          tones.add(tone);
        }
      });
    });

    if (!tones.size) {
      sourceItems.forEach(item => {
        if (
          selectedColors.some(color =>
            getFcColorFamily(item).includes(color)
          )
        ) {
          getFcColorTone(item).forEach(tone => {
            tones.add(tone);
          });
        }
      });
    }
  };

  sourceItems
  .filter(item => itemMatchesOptionScope(item, 'category'))
  .forEach(item => {
    const category = getProductType(item);

    if (category) {
      categories.add(category);
    }
  });

  sourceItems.forEach(item => {


        getFcGenres(item).forEach(value => {
      genres.add(value);
    });

    getGenreSubtypeFilters().forEach(filter => {
      getSubtypeValues(item, filter.key).forEach(value => {
        genreSubtypeValueSets.get(filter.key)?.add(value);
      });
    });

    getFcNsfw(item).forEach(value => {
      nsfw.add(value);
    });

    getFcDepartment(item).forEach(value => {
      departments.add(value);
    });

    getFcApparel(item).forEach(value => {
      apparel.add(value);
    });

    getFcFit(item).forEach(value => {
      fit.add(value);
    });

    getFcAesthetic(item).forEach(value => {
      aesthetic.add(value);
    });

    getFcServices(item).forEach(value => {
      services.add(value);
    });

    // Color and Tone are rebuilt below with self-ignore behavior.

    getTags(item).forEach(tag => {
      if (tag.startsWith('collection-')) {
        collections.add(tag);
      }
    });

    getOptions(item).forEach(option => {
      const optionLower = option.toLowerCase();

      if (knownSizes.includes(optionLower)) {
        sizes.push(option);
      }
    });
  });

colors.clear();
tones.clear();

sourceItems
  .filter(item => itemMatchesOptionScope(item, 'color'))
  .forEach(item => {
    const pairs = getFcColorTonePairs(item);

    if (selectedTones.length && pairs.length) {
      pairs.forEach(pair => {
        if (selectedTones.includes(pair.tone)) {
          colors.add(pair.family);
        }
      });

      return;
    }

    getFcColorFamily(item).forEach(value => {
      colors.add(value);
    });
  });

const toneColorScope =
  selectedColors.length
    ? selectedColors
    : [...colors];

sourceItems
  .filter(item => itemMatchesOptionScope(item, 'tone'))
  .forEach(item => {
    const pairs = getFcColorTonePairs(item);

    if (toneColorScope.length && pairs.length) {
      pairs.forEach(pair => {
        if (toneColorScope.includes(pair.family)) {
          tones.add(pair.tone);
        }
      });

      return;
    }

    getFcColorTone(item).forEach(value => {
      tones.add(value);
    });
  });

  buildDynamicFilter(
    'category',
    [...categories].map(category => ({
      value: category,
      label: formatFilterLabel(category)
    }))
  );

    buildDynamicFilter(
    'genre',
    [...genres].map(value => ({
      value,
      label: formatFilterLabel(value)
    }))
  );

  getGenreSubtypeFilters().forEach(filter => {
    const values = genreSubtypeValueSets.get(filter.key) || new Set();

    buildDynamicFilter(
      filter.key,
      [...values].map(value => ({
        value,
        label: formatFilterLabel(value)
      }))
    );
  });

  buildDynamicFilter(
    'nsfw',
    [...nsfw].map(value => ({
      value,
      label: formatFilterLabel(value)
    }))
  );

  buildDynamicFilter(
    'department',
    [...departments].map(value => ({
      value,
      label: formatFilterLabel(value)
    }))
  );

  buildDynamicFilter(
    'apparel',
    [...apparel].map(value => ({
      value,
      label: formatFilterLabel(value)
    }))
  );

  buildDynamicFilter(
    'fit',
    [...fit].map(value => ({
      value,
      label: formatFilterLabel(value)
    }))
  );

  buildDynamicFilter(
    'aesthetic',
    [...aesthetic].map(value => ({
      value,
      label: formatFilterLabel(value)
    }))
  );

  buildDynamicFilter(
    'services',
    [...services].map(value => ({
      value,
      label: formatFilterLabel(value)
    }))
  );

   getActiveFilterValues('color').forEach(color => {
  colors.add(color);
});

buildDynamicFilter(
  'color',
  [...colors].map(color => ({
    value: color,
    label: formatFilterLabel(color)
  }))
);

  getActiveFilterValues('tone').forEach(tone => {
  tones.add(tone);
});

buildDynamicFilter(
  'tone',
  [...tones].map(tone => ({
    value: tone,
    label: formatFilterLabel(tone)
  }))
);

  buildDynamicFilter('size', sizes);

  buildDynamicFilter(
    'collection',
    [...collections].map(collection => ({
      value: collection,
      label: formatFilterLabel(collection.replace(/^collection-/, ''))
    }))
  );

    syncGenreSubtypeRows();
};

const scheduleDynamicFilterRebuild = () => {
  if (filterRebuildTimer) {
    window.clearTimeout(filterRebuildTimer);
  }

  if (filterRebuildFrame) {
    window.cancelAnimationFrame(filterRebuildFrame);
  }

  filterRebuildTimer = window.setTimeout(() => {
    filterRebuildTimer = null;

    filterRebuildFrame = window.requestAnimationFrame(() => {
      filterRebuildFrame = null;

      buildProductFilters();
      syncFilterOptionStates();
      syncGenreSubtypeRows();
      syncSortUi();
    });
  }, 180);
};

const scheduleFilterApply = ({ rebuildFilters = false } = {}) => {
  if (filterApplyFrame) {
    window.clearTimeout(filterApplyFrame);
  }

  filterApplyFrame = window.setTimeout(() => {
    filterApplyFrame = null;

    window.requestAnimationFrame(() => {
      applyFilters();

      if (rebuildFilters) {
        scheduleDynamicFilterRebuild();
      }
    });
  }, 0);
};

const scheduleDrawerFilterRefresh = (attempt = 0) => {
  if (drawerFilterRefreshTimer) {
    window.clearTimeout(drawerFilterRefreshTimer);
  }

  drawerFilterRefreshTimer = window.setTimeout(() => {
    drawerFilterRefreshTimer = null;

    const hasSourceItems =
      getFilterSourceItems().length > 0;

    const hasLiveDrawerMenus =
      Boolean(
        document.querySelector(
          '#SidebarFiltersDesktop [data-fc-options], #SidebarFiltersMobile [data-fc-options]'
        )
      );

    if (hasSourceItems && hasLiveDrawerMenus) {
      buildProductFilters();
      syncFilterOptionStates();
      syncGenreSubtypeRows();
      syncSortUi();
      return;
    }

    if (attempt < 12) {
      scheduleDrawerFilterRefresh(attempt + 1);
    }
  }, attempt === 0 ? 0 : 120);
};

const syncGenreSubtypeRows = () => {
  const category = normalizeFilterValue(activeFilters.category);
  const genre = normalizeFilterValue(activeFilters.genre);

  const isApparel = category === 'apparel';
  const isServices = category === 'services' || category === 'service';

  if (!isApparel) {
    activeFilters.department = '';
    activeFilters.apparel = '';
    activeFilters.fit = '';
    activeFilters.aesthetic = '';
  }

  if (!isServices) {
    activeFilters.services = '';
  }

  const activeSubtype = getGenreSubtypeByGenre(genre);

  getGenreSubtypeKeys().forEach(key => {
    if (!activeSubtype || key !== activeSubtype.key) {
      activeFilters[key] = '';
    }
  });

  if (genre !== 'nsfw') {
    activeFilters.nsfw = '';
  }

  const hasGenreOptions =
    document.querySelector('[data-fc-options="genre"] .fc-filter-option') !== null;

  document
    .querySelectorAll('[data-fc-filter-group="genre"]')
    .forEach(group => {
      group.hidden = !hasGenreOptions;
    });

  document
    .querySelectorAll('[data-fc-filter-group="department"]')
    .forEach(group => {
      group.hidden = !isApparel;
    });

  document
    .querySelectorAll('[data-fc-filter-group="apparel"]')
    .forEach(group => {
      group.hidden = !isApparel;
    });

  document
    .querySelectorAll('[data-fc-filter-group="fit"]')
    .forEach(group => {
      group.hidden = !isApparel;
    });

  document
    .querySelectorAll('[data-fc-filter-group="aesthetic"]')
    .forEach(group => {
      group.hidden = !isApparel;
    });

  document
    .querySelectorAll('[data-fc-filter-group="services"]')
    .forEach(group => {
      group.hidden = !isServices;
    });

  getGenreSubtypeFilters().forEach(filter => {
    document
      .querySelectorAll(`[data-fc-filter-group="${filter.key}"]`)
      .forEach(group => {
        group.hidden = genre !== filter.genre;
      });
  });

  document
    .querySelectorAll('[data-fc-filter-group="nsfw"]')
    .forEach(group => {
      group.hidden = genre !== 'nsfw';
    });
};

const getNoResultsMessage = () => {
  let message = document.querySelector('.main-search-filter-no-results');

  if (!message) {
    message = document.createElement('div');
    message.className = 'main-search-filter-no-results';
    message.innerHTML = `
      <h2>No products found</h2>
      <p>Try changing or resetting your filters.</p>
    `;

    grid.closest('.shop__products-grid-wrap')?.after(message);
  }

  return message;
};

const updateProductTabs = visibleCount => {
  document
    .querySelectorAll('[data-tabs-name][data-id="products"]')
    .forEach(tab => {
      const count = tab.querySelector('.search__tab-name-count');

      if (!count) {
        if (!tab.dataset.originalCountText) {
          tab.dataset.originalCountText = tab.textContent.trim();
        }

        tab.textContent = hasActiveProductFilter()
          ? `Products (${visibleCount})`
          : tab.dataset.originalCountText;

        return;
      }

      if (!count.dataset.originalCount) {
        count.dataset.originalCount = count.textContent.trim();
      }

      count.textContent = hasActiveProductFilter()
        ? String(visibleCount)
        : count.dataset.originalCount;
    });
};

const setNativePaginationEnabled = enabled => {
  const shopComponent =
    grid.closest('shop-component');

  if (shopComponent) {
    if (!shopComponent.dataset.fcOriginalBaseParams) {
      shopComponent.dataset.fcOriginalBaseParams =
        shopComponent.getAttribute('data-base-params') || '';
    }

    if (enabled) {
      shopComponent.setAttribute(
        'data-base-params',
        shopComponent.dataset.fcOriginalBaseParams
      );
    } else {
      shopComponent.setAttribute('data-base-params', '');
    }
  }

  let paginationCache =
    document.getElementById('MainSearchNativePaginationCache');

  if (!paginationCache) {
    paginationCache = document.createElement('div');
    paginationCache.id = 'MainSearchNativePaginationCache';
    paginationCache.hidden = true;
    paginationCache.style.display = 'none';
    document.body.appendChild(paginationCache);
  }

  const paginationItems = Array.from(
    document.querySelectorAll(
      '.shop__load-button-pagination, .shop__classic-pagination, infinite-scroll-pagination'
    )
  ).filter(el => !el.closest('#MainSearchNativePaginationCache'));

  if (!enabled) {
    paginationItems.forEach(el => {
      paginationCache.appendChild(el);
    });

    return;
  }

  Array.from(paginationCache.children).forEach(el => {
    grid
      .closest('.shop__products')
      ?.appendChild(el);
  });
};

const getNextPageUrl = doc => {
  const nextLink =
    doc.querySelector('infinite-scroll-pagination a[href]') ||
    doc.querySelector('infinite-scroll-pagination [href]') ||
    doc.querySelector('[data-infinite-scroll-pagination] a[href]') ||
    doc.querySelector('[data-load-more] a[href]') ||
    doc.querySelector('.shop__load-button-pagination a[href]') ||
    doc.querySelector('.shop__classic-pagination a[href][rel="next"]') ||
    doc.querySelector('.pagination a[rel="next"]') ||
    doc.querySelector('a[rel="next"]') ||
    doc.querySelector('a[href*="page="]');

  return nextLink?.href || '';
};

const prefetchRemainingSearchProducts = async ({
  fetchAll = false,
  applyWhenDone = true
} = {}) => {
  if (grid.dataset.mainSearchPrefetching === 'true') return;
  if (grid.dataset.mainSearchPrefetched === 'true') return;

  const searchInput =
    document.querySelector('#SearchPageForm input[name="q"]');

  const rawQuery =
  searchInput?.value?.trim() || '*';

  grid.dataset.mainSearchPrefetching = 'true';

  const cache = getPrefetchCache();

  const sectionId =
    document
      .querySelector(
        '.search__results-container [data-section-id], .search [data-section-id]'
      )
      ?.dataset.sectionId;

  const fetchSearchPageItems = async (page, shopifyQuery) => {
    const params = new URLSearchParams(window.location.search);

    params.set('q', shopifyQuery);
    params.set('options[prefix]', 'last');
    params.set('type', 'product');
    params.set('page', page.toString());

    const sectionParams =
      new URLSearchParams(params);

    if (sectionId) {
      sectionParams.set('section_id', sectionId);
    }

    const pageUrl =
      `${window.location.pathname}?${sectionParams.toString()}`;

    let response = await fetch(pageUrl);
    let html = await response.text();
    let doc = new DOMParser().parseFromString(html, 'text/html');

    const incomingItems = Array.from(
      doc.querySelectorAll('#ShopProductsGrid .shop__grid-item')
    );

    if (!incomingItems.length && sectionId) {
      const fallbackUrl =
        `${window.location.pathname}?${params.toString()}`;

      response = await fetch(fallbackUrl);
      html = await response.text();
      doc = new DOMParser().parseFromString(html, 'text/html');

      incomingItems.push(
        ...doc.querySelectorAll('#ShopProductsGrid .shop__grid-item')
      );
    }

    return incomingItems;
  };

  const cacheIncomingItems = incomingItems => {
    const existingKeys = new Set(
      getItems().map(item => getProductKey(item)).filter(Boolean)
    );

    let addedCount = 0;

    incomingItems.forEach(item => {
      const key = getProductKey(item);

      if (!key || existingKeys.has(key)) return;

      item.hidden = true;
      item.dataset.fcHidden = 'true';
      item.dataset.fcPrefetched = 'true';

      cache.appendChild(item);
      existingKeys.add(key);
      addedCount++;
    });

    return addedCount;
  };

  try {
    const shopifyQuery =
  rawQuery === '*'
    ? '*'
    : rawQuery
        .split(/\s+/)
        .filter(Boolean)
        .map(word => `${word}*`)
        .join(' ');

    if (fetchAll) {
      const initialPageSize =
        Array.from(grid.querySelectorAll('.shop__grid-item'))
          .filter(item => item.dataset.fcPrefetched !== 'true').length ||
        getItems().length ||
        16;

      const sourceCount =
        getFilterSourceItems().length;

      const totalPages =
        Math.min(
          20,
          Math.max(2, Math.ceil(sourceCount / initialPageSize))
        );

      const pageNumbers =
        Array.from(
          { length: totalPages - 1 },
          (_, index) => index + 2
        );

      await Promise.all(
        pageNumbers.map(async page => {
          const incomingItems =
            await fetchSearchPageItems(page, shopifyQuery);

          cacheIncomingItems(incomingItems);

          if (
            hasActiveProductFilter() ||
            Boolean(activeFilters.sort)
          ) {
            requestAnimationFrame(() => {
              applyFilters();
            });
          }
        })
      );

      grid.dataset.mainSearchPrefetched = 'true';
      buildProductFilters();
      return;
    }

    let page = 2;
    let safety = 0;

    while (safety < 20) {
      safety++;

      const incomingItems =
        await fetchSearchPageItems(page, shopifyQuery);

      if (!incomingItems.length) {
        break;
      }

      const addedCount =
        cacheIncomingItems(incomingItems);

      const expectedMatchCount =
        getFilterSourceItems().filter(item => matchesItem(item)).length;

      const currentRenderableMatchKeys =
        new Set(
          getItems()
            .filter(item => matchesItem(item))
            .map(item => getProductKey(item))
            .filter(Boolean)
        );

      const currentRenderableMatchCount =
        currentRenderableMatchKeys.size;

      const shouldStopAfterRenderableMatch =
        !fetchAll ||
        hasActiveProductFilter() ||
        Boolean(activeFilters.sort);

      if (
        shouldStopAfterRenderableMatch &&
        expectedMatchCount > 0 &&
        currentRenderableMatchCount > 0
      ) {
        break;
      }

      if (addedCount === 0) {
        break;
      }

      page++;
    }

    grid.dataset.mainSearchPrefetched = 'true';
    buildProductFilters();

  } catch (error) {
    console.error(error);
  } finally {
    grid.dataset.mainSearchPrefetching = 'false';

    const shouldApplyAfterPrefetch =
      applyWhenDone ||
      hasActiveProductFilter() ||
      Boolean(activeFilters.sort);

    if (!shouldApplyAfterPrefetch) {
      buildProductFilters();
      syncActiveFilterChrome(false);
      updateProductCountText(getFilterSourceItems().length || getItems().length);
      document.body.classList.remove('main-search-loading');
      return;
    }

    requestAnimationFrame(() => {
      applyFilters();

      requestAnimationFrame(() => {
        document.body.classList.remove('main-search-loading');
      });
    });
  }
};

const scheduleSearchProductWarmup = () => {
  if (grid.dataset.mainSearchWarmupScheduled === 'true') return;

  grid.dataset.mainSearchWarmupScheduled = 'true';

  const runWarmup = () => {
    if (!document.body.contains(grid)) return;
    if (grid.dataset.mainSearchPrefetched === 'true') return;

    prefetchRemainingSearchProducts({
      fetchAll: true,
      applyWhenDone: false
    });
  };

  window.setTimeout(runWarmup, 120);
};

const appendPrefetchedSearchBatch = (batchSize = 16) => {
  if (hasActiveProductFilter() || Boolean(activeFilters.sort)) return false;

  grid.dataset.fcAppendingCachedBatch = 'true';
  grid.closest('.shop__products-grid-wrap')?.classList.add('fc-appending-cached-batch');

  const cache =
    document.getElementById('MainSearchPrefetchCache');

  if (!cache) {
    grid.dataset.fcAppendingCachedBatch = 'false';
    grid.closest('.shop__products-grid-wrap')?.classList.remove('fc-appending-cached-batch');
    return false;
  }

  const items =
    Array.from(cache.querySelectorAll('.shop__grid-item')).slice(0, batchSize);

  if (!items.length) {
    grid.dataset.fcAppendingCachedBatch = 'false';
    grid.closest('.shop__products-grid-wrap')?.classList.remove('fc-appending-cached-batch');
    return false;
  }

  grid.dataset.fcApplyingFilters = 'true';

  window.setTimeout(() => {
    items.forEach(item => {
      item.hidden = false;
      item.dataset.fcHidden = 'false';
      item.style.display = '';
      grid.appendChild(item);
    });

    requestAnimationFrame(() => {
      updateProductCountText(getFilterSourceItems().length || getItems().length);
      grid.dataset.fcApplyingFilters = 'false';
      grid.dataset.fcAppendingCachedBatch = 'false';
      grid.closest('.shop__products-grid-wrap')?.classList.remove('fc-appending-cached-batch');
    });
  }, 140);

  return true;
};

let cachedInfiniteScrollFrame = null;

const maybeAppendPrefetchedSearchBatch = () => {
  if (cachedInfiniteScrollFrame) return;

  cachedInfiniteScrollFrame = requestAnimationFrame(() => {
    cachedInfiniteScrollFrame = null;

    const distanceToBottom =
      document.documentElement.scrollHeight -
      window.innerHeight -
      window.scrollY;

    if (distanceToBottom > 700) return;

    appendPrefetchedSearchBatch();
  });
};

const sortItems = () => {
  let sorted = [...getItems()];

  if (!activeFilters.sort || activeFilters.sort === 'relevant') {
    sorted = [...getItems()];
  }

  if (activeFilters.sort === 'title-ascending') {
    sorted.sort((a, b) => getTitle(a).localeCompare(getTitle(b)));
  }

  if (activeFilters.sort === 'title-descending') {
    sorted.sort((a, b) => getTitle(b).localeCompare(getTitle(a)));
  }

  if (activeFilters.sort === 'price-ascending') {
    sorted.sort((a, b) => getPrice(a) - getPrice(b));
  }

  if (activeFilters.sort === 'price-descending') {
    sorted.sort((a, b) => getPrice(b) - getPrice(a));
  }

  if (activeFilters.sort === 'created-descending') {
    sorted.sort((a, b) => getDate(b) - getDate(a));
  }

  if (activeFilters.sort === 'created-ascending') {
    sorted.sort((a, b) => getDate(a) - getDate(b));
  }

  sorted.forEach(item => grid.appendChild(item));
};

const labelize = value =>
    value
    .toString()
    .trim()
    .replace(/^collection-/, '')
    .replace(/^nsfw$/, 'NSFW')
    .replace(/-/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/\b\w/g, letter => letter.toUpperCase());

const renderActivePills = () => {
  const container = document.querySelector('[data-fc-active-filters]');

  if (!container) return;

  const pills = [];

  if (activeFilters.search) {
  pills.push([
    'search',
    activeFilters.search,
    `Search: ${activeFilters.search}`
  ]);
}

  if (activeFilters.category) {
    pills.push(['category', activeFilters.category, labelize(activeFilters.category)]);
  }

  if (activeFilters.genre) {
    pills.push(['genre', activeFilters.genre, labelize(activeFilters.genre)]);
  }

  getGenreSubtypeFilters().forEach(filter => {
    if (activeFilters[filter.key]) {
      pills.push([
        filter.key,
        activeFilters[filter.key],
        labelize(activeFilters[filter.key])
      ]);
    }
  });

  if (activeFilters.nsfw) {
    pills.push(['nsfw', activeFilters.nsfw, labelize(activeFilters.nsfw)]);
  }

  if (activeFilters.department) {
    pills.push(['department', activeFilters.department, labelize(activeFilters.department)]);
  }

  if (activeFilters.apparel) {
    pills.push(['apparel', activeFilters.apparel, labelize(activeFilters.apparel)]);
  }

  if (activeFilters.fit) {
    pills.push(['fit', activeFilters.fit, labelize(activeFilters.fit)]);
  }

  if (activeFilters.aesthetic) {
    pills.push(['aesthetic', activeFilters.aesthetic, labelize(activeFilters.aesthetic)]);
  }

  if (activeFilters.services) {
    pills.push(['services', activeFilters.services, labelize(activeFilters.services)]);
  }

  getActiveFilterValues('color').forEach(value => {
    pills.push(['color', value, labelize(value)]);
  });

  getActiveFilterValues('tone').forEach(value => {
    pills.push(['tone', value, labelize(value)]);
  });

  if (activeFilters.size) {
    pills.push(['size', activeFilters.size, activeFilters.size.toUpperCase()]);
  }

  if (activeFilters.collection) {
    pills.push([
      'collection',
      activeFilters.collection,
      labelize(activeFilters.collection.replace(/^collection-/, ''))
    ]);
  }


  if (!pills.length) {
    container.hidden = true;
    container.innerHTML = '';
    return;
  }

  container.hidden = false;

  container.innerHTML = pills
    .map(([key, value, label]) => `
      <button
        type="button"
        class="fc-active-filter-pill ${isColorToneSelectionTemporarilyUnavailable(key, value) ? 'fc-temporarily-unavailable' : ''}"
        data-fc-remove-filter="${key}"
        data-fc-remove-value="${value}"
      >
        <span>${label}</span>
        <span aria-hidden="true">×</span>
      </button>
    `)
    .join('');

  container.insertAdjacentHTML(
    'beforeend',
    `
      <button
        type="button"
        class="fc-active-filter-clear"
        data-fc-clear-all
      >
        Clear All
      </button>
    `
  );
};

const syncFilterOptionStates = () => {
  document.querySelectorAll('.fc-filter-option').forEach(button => {
    const key = button.dataset.fcFilter;
    const value = button.dataset.fcValue;

    if (!key) return;

    button.classList.toggle(
      'selected',
      isActiveFilterValue(key, value)
    );
  });
};

const syncSortUi = () => {
  const activeValue = activeFilters.sort || '';

  document.querySelectorAll('[data-fc-sort-option]').forEach(button => {
    button.classList.toggle(
      'active',
      (button.dataset.fcSortValue || '') === activeValue
    );
  });

  const activeButton = Array.from(
    document.querySelectorAll('[data-fc-sort-option]')
  ).find(button => (button.dataset.fcSortValue || '') === activeValue);

  const label = activeButton?.textContent?.trim() || 'Relevance';

  document.querySelectorAll('[data-fc-sort-label]').forEach(el => {
    el.textContent = label;
  });
};

const updateProductCountText = count => {
  const normalizedCount = Number(count) || 0;

  document
    .querySelectorAll('#ShopProductCount, .shop__product-count')
    .forEach(el => {
      el.textContent = activeFilters.search
        ? `${normalizedCount} product${normalizedCount === 1 ? '' : 's'}`
        : `Browsing all products (${normalizedCount})`;
    });
};

const syncActiveFilterChrome = hasActiveFilters => {
  document
    .querySelectorAll('.fc-filter-actions [data-fc-clear-all]')
    .forEach(button => {
      button.textContent = hasActiveFilters ? 'Clear' : 'Close';
      button.dataset.fcMode = hasActiveFilters ? 'clear' : 'close';
    });

  syncFilterOptionStates();
  syncGenreSubtypeRows();
  renderActivePills();
  syncSortUi();
};

const getCardVariantMap = card => {
  if (cardVariantMapCache.has(card)) {
    return cardVariantMapCache.get(card);
  }

  const item = card.closest('.shop__grid-item');
  const script =
    card.querySelector('[data-fc-variant-map]') ||
    item?.querySelector('[data-fc-variant-map]');

  if (!script) {
    cardVariantMapCache.set(card, []);
    return [];
  }

  try {
    const variants = JSON.parse(script.textContent || '[]');
    const normalizedVariants = Array.isArray(variants) ? variants : [];

    cardVariantMapCache.set(card, normalizedVariants);
    return normalizedVariants;
  } catch (error) {
    cardVariantMapCache.set(card, []);
    return [];
  }
};

const getVariantFamily = variant =>
  normalizeFilterValue(
    variant.family ||
    variant.color_family ||
    variant.colorFamily ||
    variant.variant_color_family ||
    variant.variantColorFamily ||
    variant.option ||
    variant.option1 ||
    variant.color ||
    variant.title ||
    ''
  );

const getVariantTone = variant =>
  normalizeFilterValue(
    variant.tone ||
    variant.color_tone ||
    variant.colorTone ||
    variant.variant_color_tone ||
    variant.variantColorTone ||
    ''
  );

const getVariantImage = variant =>
  variant.image ||
  variant.featured_image ||
  variant.featuredImage ||
  variant.image_url ||
  variant.imageUrl ||
  variant.src ||
  '';

const syncCardVariantImage = card => {
  const selectedColors = getActiveFilterValues('color');
  const selectedTones = getActiveFilterValues('tone');

  const hasVariantFilter =
    selectedColors.length || selectedTones.length;

  const variants = getCardVariantMap(card)
    .filter(variant => getVariantImage(variant));

  if (!variants.length) return;

  const swatches = [
    ...card.querySelectorAll('[data-color-swatches-item][data-variant-id]')
  ];

  const variantImages = [
    ...card.querySelectorAll('.product-card__images > img[data-variant-id]')
  ];

  const carouselImages = [
    ...card.querySelectorAll('.product-card__carousel-container .product-card__slide img')
  ];

  const desktopImages = [
    ...card.querySelectorAll('.product-card__images > img:not([data-variant-id])')
  ];

  const storeOriginal = el => {
    if (!el) return;

    if (!el.dataset.fcOriginalVariantId && el.dataset.variantId) {
      el.dataset.fcOriginalVariantId = el.dataset.variantId;
    }

    if (!el.dataset.fcOriginalHref && el.getAttribute('href')) {
      el.dataset.fcOriginalHref = el.getAttribute('href');
    }

    if (!el.dataset.fcOriginalAriaLabel && el.getAttribute('aria-label')) {
      el.dataset.fcOriginalAriaLabel = el.getAttribute('aria-label');
    }

    if (!el.dataset.fcOriginalColor && el.dataset.color) {
      el.dataset.fcOriginalColor = el.dataset.color;
    }

    if (!el.dataset.fcOriginalSrc && el.getAttribute('src')) {
      el.dataset.fcOriginalSrc = el.getAttribute('src');
    }

    if (!el.dataset.fcOriginalSrcset) {
      el.dataset.fcOriginalSrcset =
        el.getAttribute('srcset') ||
        el.getAttribute('data-srcset') ||
        '';
    }
  };

  [...swatches, ...variantImages, ...carouselImages, ...desktopImages]
    .forEach(storeOriginal);

  const restoreOriginals = () => {
    swatches.forEach(swatch => {
      if (swatch.dataset.fcOriginalVariantId) {
        swatch.dataset.variantId = swatch.dataset.fcOriginalVariantId;
      }

      if (swatch.dataset.fcOriginalHref) {
        swatch.setAttribute('href', swatch.dataset.fcOriginalHref);
      }

      if (swatch.dataset.fcOriginalAriaLabel) {
        swatch.setAttribute('aria-label', swatch.dataset.fcOriginalAriaLabel);
      }

      if (swatch.dataset.fcOriginalColor) {
        swatch.dataset.color = swatch.dataset.fcOriginalColor;
      }
    });

    [...variantImages, ...carouselImages, ...desktopImages].forEach(img => {
      if (img.dataset.fcOriginalVariantId) {
        img.dataset.variantId = img.dataset.fcOriginalVariantId;
      }

      if (img.dataset.fcOriginalSrc) {
        img.setAttribute('src', img.dataset.fcOriginalSrc);
      }

      if (img.dataset.fcOriginalSrcset) {
        img.setAttribute('srcset', img.dataset.fcOriginalSrcset);
      } else {
        img.removeAttribute('srcset');
        img.removeAttribute('data-srcset');
      }
    });
  };

  restoreOriginals();

  if (!hasVariantFilter) return;

  const selectedVariants = [];

  selectedColors.forEach(color => {
    const match = variants.find(variant => {
      const family = getVariantFamily(variant);
      const tone = getVariantTone(variant);

      return (
        family === color &&
        (
          !selectedTones.length ||
          selectedTones.includes(tone)
        )
      );
    });

    if (match && !selectedVariants.some(item => getVariantFamily(item) === color)) {
      selectedVariants.push(match);
    }
  });

  if (!selectedVariants.length && selectedTones.length) {
    selectedTones.forEach(tone => {
      const match = variants.find(variant =>
        getVariantTone(variant) === tone
      );

      if (match && !selectedVariants.includes(match)) {
        selectedVariants.push(match);
      }
    });
  }

  const selectedFamilies =
    selectedVariants.map(variant => getVariantFamily(variant));

  const remainingVariants = [];

  variants.forEach(variant => {
    const family = getVariantFamily(variant);

    if (!family) return;
    if (selectedFamilies.includes(family)) return;

    if (!remainingVariants.some(item => getVariantFamily(item) === family)) {
      remainingVariants.push(variant);
    }
  });

  const finalVariants =
    [...selectedVariants, ...remainingVariants];

  finalVariants.forEach((variant, index) => {
    const variantId = String(variant.id || '');
    const variantImage = getVariantImage(variant);
    const variantUrl = variant.url || card.dataset.url || '';
    const variantTitle = variant.title || variant.color || '';
    const variantColor = variant.color || variantTitle || getVariantFamily(variant);

    const swatch = swatches[index];
    const variantImageNode = variantImages[index];
    const carouselImage = carouselImages[index];
    const desktopImage = desktopImages[index];

    if (swatch) {
      swatch.dataset.variantId = variantId;

      if (variantUrl) {
        swatch.setAttribute('href', variantUrl);
      }

      if (variantTitle) {
        swatch.setAttribute('aria-label', variantTitle);
      }

      if (variantColor) {
        swatch.dataset.color = variantColor;
      }

      const swatchImg = swatch.querySelector('img');

      if (swatchImg && variantImage) {
        swatchImg.setAttribute('src', variantImage);
        swatchImg.removeAttribute('srcset');
        swatchImg.removeAttribute('data-srcset');
      }
    }

    if (variantImageNode) {
      variantImageNode.dataset.variantId = variantId;

      if (variantImage) {
        variantImageNode.setAttribute('src', variantImage);
        variantImageNode.removeAttribute('srcset');
        variantImageNode.removeAttribute('data-srcset');
      }
    }

    [carouselImage, desktopImage].filter(Boolean).forEach(img => {
      if (variantImage) {
        img.setAttribute('src', variantImage);
        img.removeAttribute('srcset');
        img.removeAttribute('data-srcset');
      }
    });
  });
};

const syncVisibleCardVariantImages = () => {
  const visibleCards = Array.from(
    grid.querySelectorAll('.shop__grid-item:not([hidden]) product-card')
  ).filter(card => {
    const item = card.closest('.shop__grid-item');

    return item && item.dataset.fcHidden !== 'true';
  });

  visibleCards.forEach(card => {
    syncCardVariantImage(card);
  });
};

const matchesItem = item => {
  if (!item) return false;

  if (
    activeFilters.category &&
    getProductType(item) !== activeFilters.category
  ) {
    return false;
  }

  if (
    activeFilters.genre &&
    !itemHasGenre(item, activeFilters.genre)
  ) {
    return false;
  }

  for (const filter of getGenreSubtypeFilters()) {
    if (
      activeFilters[filter.key] &&
      !getSubtypeValues(item, filter.key).includes(activeFilters[filter.key])
    ) {
      return false;
    }
  }

  if (
    activeFilters.nsfw &&
    !getFcNsfw(item).includes(activeFilters.nsfw)
  ) {
    return false;
  }

  if (
    activeFilters.department &&
    !getFcDepartment(item).includes(activeFilters.department)
  ) {
    return false;
  }

  if (
    activeFilters.apparel &&
    !getFcApparel(item).includes(activeFilters.apparel)
  ) {
    return false;
  }

  if (
    activeFilters.fit &&
    !getFcFit(item).includes(activeFilters.fit)
  ) {
    return false;
  }

  if (
    activeFilters.aesthetic &&
    !getFcAesthetic(item).includes(activeFilters.aesthetic)
  ) {
    return false;
  }

  if (
    activeFilters.services &&
    !getFcServices(item).includes(activeFilters.services)
  ) {
    return false;
  }

     const selectedColors = getActiveFilterValues('color');
  const selectedTones = getActiveFilterValues('tone');

  if (selectedColors.length && selectedTones.length) {
    const card =
      item.querySelector('product-card') ||
      item.closest('.shop__grid-item')?.querySelector('product-card');

    const variants = card ? getCardVariantMap(card) : [];

    const hasPairedVariantMatch = variants.some(variant =>
  selectedColors.includes(getVariantFamily(variant)) &&
  selectedTones.includes(getVariantTone(variant))
);

    if (!hasPairedVariantMatch) {
      return false;
    }

  } else if (
    selectedColors.length &&
    !selectedColors.some(value =>
      getFcColorFamily(item).includes(value)
    )
  ) {
    return false;

  } else if (
    selectedTones.length &&
    !selectedTones.some(value =>
      getFcColorTone(item).includes(value)
    )
  ) {
    return false;
  }

  if (
    activeFilters.size &&
    !getOptions(item).map(option => option.toLowerCase()).includes(activeFilters.size)
  ) {
    return false;
  }

  if (
    activeFilters.collection &&
    !getTags(item).includes(activeFilters.collection)
  ) {
    return false;
  }

  return true;
};

const matchesCard = card => {
  const item = card.closest('.shop__grid-item');

  return matchesItem(item);
};

const applyFilters = () => {
  grid.dataset.fcApplyingFilters = 'true';
  grid.classList.add('fc-grid-syncing-variant-images');

  syncGenreSubtypeRows();

  const hasActiveFilters =
  hasActiveProductFilter() || Boolean(activeFilters.sort);

  setNativePaginationEnabled(!hasActiveFilters);
  syncActiveFilterChrome(hasActiveFilters);

  if (
    hasActiveFilters &&
    grid.dataset.mainSearchPrefetching === 'true'
  ) {
    grid.classList.remove('fc-grid-syncing-variant-images');
    grid.dataset.fcApplyingFilters = 'false';

    return;
  }

  const allItems = getItems();
  const filterSourceItems = getFilterSourceItems();
  const matchCache = new WeakMap();
  const getCachedMatch = item => {
    if (!item) return false;

    if (!matchCache.has(item)) {
      matchCache.set(item, matchesItem(item));
    }

    return matchCache.get(item);
  };

  const expectedMatchCount =
    filterSourceItems.filter(item => getCachedMatch(item)).length;

  const renderableMatchKeys =
    new Set(
      allItems
        .filter(item => getCachedMatch(item))
        .map(item => getProductKey(item))
        .filter(Boolean)
    );

  const renderableMatchCount =
    renderableMatchKeys.size;

  const needsMoreRenderableMatches =
    expectedMatchCount > renderableMatchCount &&
    renderableMatchCount === 0;

  if (
    hasActiveFilters &&
    needsMoreRenderableMatches &&
    grid.dataset.mainSearchPrefetched !== 'true' &&
    grid.dataset.mainSearchPrefetching !== 'true'
  ) {
    prefetchRemainingSearchProducts();

    grid.classList.remove('fc-grid-syncing-variant-images');
    grid.dataset.fcApplyingFilters = 'false';

    return;
  }

    const shouldUseFullPrefetchedSet =
    grid.dataset.mainSearchPrefetched === 'true';

  const alreadyRenderedInitialKeys = new Set(
    Array.from(grid.querySelectorAll('.shop__grid-item'))
      .filter(item => item.dataset.fcPrefetched !== 'true')
      .map(item => getProductKey(item))
      .filter(Boolean)
  );

  allItems
    .map(item => item.querySelector('product-card'))
    .filter(Boolean)
    .forEach(card => {
    const item = card.closest('.shop__grid-item');

    if (!item) return;

    const productKey = getProductKey(item);

    const isPrefetched =
      item.dataset.fcPrefetched === 'true';

    const isMatch = getCachedMatch(item);

    if (!shouldUseFullPrefetchedSet && isPrefetched) {
      if (item.parentElement !== getPrefetchCache()) {
        getPrefetchCache().appendChild(item);
      }

      item.hidden = true;
      item.dataset.fcHidden = 'true';
      item.style.display = 'none';
      return;
    }

    if (
      shouldUseFullPrefetchedSet &&
      isPrefetched &&
      isMatch &&
      productKey &&
      alreadyRenderedInitialKeys.has(productKey)
    ) {
      getPrefetchCache().appendChild(item);
      item.hidden = true;
      item.dataset.fcHidden = 'true';
      item.style.display = 'none';
      return;
    }

    if (shouldUseFullPrefetchedSet && isPrefetched && isMatch) {
      grid.appendChild(item);
    }

    if (shouldUseFullPrefetchedSet && isPrefetched && !isMatch) {
      getPrefetchCache().appendChild(item);
    }

    item.hidden = !isMatch;
    item.dataset.fcHidden = isMatch ? 'false' : 'true';
    item.style.display = isMatch ? '' : 'none';
  });

  const visibleProductKeys = new Set();

  Array.from(grid.querySelectorAll('.shop__grid-item')).forEach(item => {
    if (item.hidden || item.dataset.fcHidden === 'true') return;

    const key = getVisibleDedupeKey(item);

    if (!key) return;

    if (visibleProductKeys.has(key)) {
      item.hidden = true;
      item.dataset.fcHidden = 'true';
      item.style.display = 'none';
      return;
    }

    visibleProductKeys.add(key);
  });

    const visibleCount =
    Array.from(grid.querySelectorAll('.shop__grid-item'))
      .filter(item => !item.hidden && item.dataset.fcHidden !== 'true').length;

  const filterCount =
    filterSourceItems.length
      ? expectedMatchCount
      : visibleCount;

  document
    .querySelectorAll('.sidebar-filters__header-label')
    .forEach(header => {
      let count = header.querySelector('.filters__results-count');

      if (!count) {
        count = document.createElement('div');
        count.className = 'filters__results-count';
        header.appendChild(count);
      }

      count.textContent = `(${filterCount} result${filterCount === 1 ? '' : 's'})`;
    });

  const displayCount =
  grid.dataset.mainSearchPrefetched === 'true'
    ? filterCount
    : visibleCount;

  updateProductCountText(displayCount);

  const noResultsMessage = getNoResultsMessage();

  const isStillPrefetching =
    grid.dataset.mainSearchPrefetching === 'true';

  const isWaitingForRenderableMatches =
    needsMoreRenderableMatches || isStillPrefetching;

  noResultsMessage.style.display =
    visibleCount === 0 && !isWaitingForRenderableMatches ? 'block' : 'none';

  grid.style.display =
    visibleCount === 0 && !isWaitingForRenderableMatches ? 'none' : '';

  syncFilterOptionStates();
  syncGenreSubtypeRows();
  updateProductTabs(visibleCount);
  renderActivePills();
  syncSortUi();

  requestAnimationFrame(() => {
    syncVisibleCardVariantImages();

    requestAnimationFrame(() => {
      grid.classList.remove('fc-grid-syncing-variant-images');
      grid.dataset.fcApplyingFilters = 'false';
    });
  });
};

document.addEventListener(
  'click',
  event => {
    const removePill = event.target.closest('[data-fc-remove-filter]');

    if (removePill) {
      event.preventDefault();

      const key = removePill.dataset.fcRemoveFilter;

      if (key === 'search') {
        activeFilters.search = '';
        input.value = '';

        const cleanParams =
          new URLSearchParams(window.location.search);

        cleanParams.delete('q');
        cleanParams.delete('handoff');

        window.history.replaceState(
          {},
          '',
          cleanParams.toString()
            ? `${window.location.pathname}?${cleanParams.toString()}`
            : window.location.pathname
        );

        renderActivePills();
        syncFilterOptionStates();
        scheduleFilterApply();

        return;
      }

      if (key && key in activeFilters) {
        clearActiveFilterValue(key, removePill.dataset.fcRemoveValue || '');
      }

      renderActivePills();
      syncFilterOptionStates();
      scheduleFilterApply({ rebuildFilters: true });

      return;
    }

    const clearPill = event.target.closest('.fc-active-filter-clear');

if (clearPill) {
  event.preventDefault();

  const hadSearchQuery =
    Boolean(activeFilters.search || input.value.trim());

  activeFilters.search = '';

  activeFilters.category = '';

  activeFilters.genre = '';

  getGenreSubtypeKeys().forEach(key => {
    activeFilters[key] = '';
  });

  activeFilters.nsfw = '';

  activeFilters.department = '';
  activeFilters.apparel = '';
  activeFilters.fit = '';
  activeFilters.aesthetic = '';

  activeFilters.services = '';

  activeFilters.color = [];
  activeFilters.tone = [];
  activeFilters.size = '';
  activeFilters.collection = '';

  activeFilters.sort = '';

  input.value = '';

  document
    .getElementById('MainSearchPrefetchCache')
    ?.remove();

  const currentGrid =
    document.querySelector('#ShopProductsGrid');

  if (currentGrid) {
    delete currentGrid.dataset.mainSearchPrefetched;
    delete currentGrid.dataset.mainSearchPrefetching;
  }

  if (hadSearchQuery) {
    updateResults();
    return;
  }

  renderActivePills();
  syncFilterOptionStates();
  syncSortUi();
  scheduleFilterApply({ rebuildFilters: true });

  return;
}

    const option = event.target.closest('.fc-filter-option, [data-fc-sort-option]');

    if (!option) {
      return;
    }

    if (
      option.closest('#SidebarFiltersDesktop') ||
      option.closest('#SidebarFiltersMobile')
    ) {
      event.stopPropagation();
    }

    event.preventDefault();

    const key = option.dataset.fcSortOption !== undefined
      ? 'sort'
      : option.dataset.fcFilter;

    const value = option.dataset.fcSortOption !== undefined
      ? option.dataset.fcSortValue || ''
      : normalizeFilterValue(option.dataset.fcValue || '');

    if (!key) return;

    toggleActiveFilterValue(key, value);

    if (key === 'genre') {
      const activeSubtype = getGenreSubtypeByGenre(activeFilters.genre);

      getGenreSubtypeKeys().forEach(subtypeKey => {
        if (!activeSubtype || subtypeKey !== activeSubtype.key) {
          activeFilters[subtypeKey] = '';
        }
      });

      if (activeFilters.genre !== 'nsfw') {
        activeFilters.nsfw = '';
      }
    }

    if (key === 'category') {
      const category = normalizeFilterValue(activeFilters.category);

      if (category !== 'apparel') {
        activeFilters.department = '';
        activeFilters.apparel = '';
        activeFilters.fit = '';
        activeFilters.aesthetic = '';
      }

      if (category !== 'services' && category !== 'service') {
        activeFilters.services = '';
      }
    }

    syncFilterOptionStates();

        if (key === 'sort') {
      sortItems();

      const sortDrawer =
        option.closest('#SortListSidebar');

      const sortDropdown =
        option.closest('#SortList');

      sortDrawer
        ?.querySelector('[data-sidebar-button]')
        ?.click();

      if (sortDropdown) {
        sortDropdown.setAttribute('aria-hidden', 'true');
      }
    }

    if (key !== 'sort') {
      option.classList.toggle(
        'selected',
        isActiveFilterValue(key, value)
      );

      renderActivePills();
      scheduleFilterApply({ rebuildFilters: true });
      return;
    }

    applyFilters();
  },
  { signal }
);

document.addEventListener(
  'click',
  event => {
    const clearButton = event.target.closest('.fc-filter-actions [data-fc-clear-all]');

    if (!clearButton) return;

    event.preventDefault();

    if (clearButton.dataset.fcMode === 'close') {
      const sidebar =
        clearButton.closest('#SidebarFiltersMobile') ||
        clearButton.closest('#SidebarFiltersDesktop') ||
        clearButton.closest('sidebar-filters-mobile') ||
        clearButton.closest('sidebar-filters-desktop');

      const closeButton = sidebar?.querySelector('[data-sidebar-button]');
      closeButton?.click();

      return;
    }

        activeFilters.category = '';

        activeFilters.genre = '';

        getGenreSubtypeKeys().forEach(key => {
          activeFilters[key] = '';
        });

        activeFilters.nsfw = '';

        activeFilters.department = '';
        activeFilters.apparel = '';
        activeFilters.fit = '';
        activeFilters.aesthetic = '';

        activeFilters.services = '';

        activeFilters.color = [];
        activeFilters.tone = [];
        activeFilters.size = '';
        activeFilters.collection = '';

        activeFilters.sort = '';

    renderActivePills();
    syncFilterOptionStates();
    syncSortUi();
    scheduleFilterApply({ rebuildFilters: true });

    clearButton.blur();
  },
  { signal }
);

document.addEventListener(
  'click',
  event => {
    const applyButton = event.target.closest('[data-fc-apply]');

    if (!applyButton) return;

    event.preventDefault();

    applyButton
      .closest('#SidebarFiltersDesktop, #SidebarFiltersMobile')
      ?.querySelector('[data-sidebar-button]')
      ?.click();
  },
  { signal }
);

buildProductFilters();
sortItems();
applyFilters();
scheduleSearchProductWarmup();

let isApplyingGridMutation = false;

const gridObserver = new MutationObserver(mutations => {
  if (isApplyingGridMutation) return;
  if (grid.dataset.fcApplyingFilters === 'true') return;

  const addedItems = [];

  mutations.forEach(mutation => {
    Array.from(mutation.addedNodes).forEach(node => {
      if (node.nodeType !== 1) return;

      if (node.classList?.contains('shop__grid-item')) {
        addedItems.push(node);
        return;
      }

      node
        .querySelectorAll?.('.shop__grid-item')
        .forEach(item => addedItems.push(item));
    });
  });

  if (!addedItems.length) return;

  if (hasActiveProductFilter() || Boolean(activeFilters.sort)) {
    addedItems.forEach(item => {
      item.remove();
    });

    setNativePaginationEnabled(false);

    return;
  }

  isApplyingGridMutation = true;

  window.requestAnimationFrame(() => {
    grid
      .querySelectorAll('.shop__grid-item')
      .forEach(item => {
        const isMatch = matchesItem(item);

        item.hidden = !isMatch;
        item.dataset.fcHidden = isMatch ? 'false' : 'true';
        item.style.display = isMatch ? '' : 'none';
      });

    isApplyingGridMutation = false;
  });
});

gridObserver.observe(grid, {
  childList: true,
  subtree: false
});

signal.addEventListener('abort', () => {
  gridObserver.disconnect();
});

window.addEventListener(
  'scroll',
  maybeAppendPrefetchedSearchBatch,
  { passive: true, signal }
);

document.addEventListener(
  'click',
  event => {
    const drawerButton = event.target.closest(
      '[data-sidebar-id="SidebarFiltersDesktop"], [data-sidebar-id="SidebarFiltersMobile"]'
    );

    if (!drawerButton) return;

    window.requestAnimationFrame(() => {
      scheduleDrawerFilterRefresh();
    });
  },
  { signal }
);


};



  const updateResults = async ({ showLoader = true } = {}) => {

    if (showLoader) {
      document.body.classList.add('main-search-loading');
    }

    const rawQuery =
  input.value;

const query =
  rawQuery.trim();

if (window.mainSearchActiveFilters) {
  window.mainSearchActiveFilters.search = query === '*' ? '' : query;
}

   const shouldLoadAllProducts =
  !query.length;

if (shouldLoadAllProducts) {
  document
    .getElementById('MainSearchPrefetchCache')
    ?.remove();
}

    const params =
      new URLSearchParams(
        window.location.search
      );

    params.delete('handoff');

    const shopifyQuery =
  query.length
    ? query
        .split(/\s+/)
        .filter(Boolean)
        .map(word => `${word}*`)
        .join(' ')
    : '*';

params.set('q', shopifyQuery);

    params.set(
      'options[prefix]',
      'last'
    );

    const sectionId =
      document
        .querySelector(
          '.search__results-container [data-section-id], .search [data-section-id]'
        )
        ?.dataset.sectionId;

    const fullUrl =
      `${window.location.pathname}?${params.toString()}`;

    const sectionParams =
      new URLSearchParams(params);

    if (sectionId) {
      sectionParams.set('section_id', sectionId);
    }

    const url =
      sectionId
        ? `${window.location.pathname}?${sectionParams.toString()}`
        : fullUrl;

    const displayParams = new URLSearchParams(window.location.search);

displayParams.delete('handoff');

if (query.length) {
  displayParams.set('q', query);
  displayParams.set('options[prefix]', 'last');

  window.history.replaceState(
    {},
    '',
    `${window.location.pathname}?${displayParams.toString()}`
  );
} else {
  window.history.replaceState(
    {},
    '',
    window.location.pathname
  );
}

input.value = rawQuery;

    if (controller) {
      controller.abort();
    }

    controller =
      new AbortController();

    const currentRequest =
      ++requestId;

    try {

      const response =
        await fetch(url, {
          signal:
            controller.signal
        });

      let html =
        await response.text();

      if (
        currentRequest !== requestId
      ) {
        return;
      }

      const parser =
        new DOMParser();

      let doc =
        parser.parseFromString(
          html,
          'text/html'
        );

      let incomingResults =
        doc.querySelector(
          '.search__results-container'
        );

      if (
        sectionId &&
        !incomingResults
      ) {
        const fallbackResponse =
          await fetch(fullUrl, {
            signal:
              controller.signal
          });

        html =
          await fallbackResponse.text();

        doc =
          parser.parseFromString(
            html,
            'text/html'
          );

        incomingResults =
          doc.querySelector(
            '.search__results-container'
          );
      }

      const currentResults =
        document.querySelector(
          '.search__results-container'
        );

      const incomingEmpty =
        doc.querySelector(
          '.search__no-results-note'
        );

      const currentEmpty =
        document.querySelector(
          '.search__no-results-note'
        );

      // INITIAL SEARCH
if (
  !currentResults &&
  incomingResults
) {

  const searchSection =
    document.querySelector('.search');

  const searchContainer =
    document.querySelector('.search__container');

  if (searchSection && searchContainer) {
   searchContainer.insertAdjacentElement(
  'afterend',
  incomingResults.cloneNode(true)
);

document
  .querySelector('.main-search-loader-results')
  ?.remove();

    input.value = rawQuery;

document
  .getElementById('MainSearchPrefetchCache')
  ?.remove();

const incomingGrid =
  document.querySelector('#ShopProductsGrid');

if (incomingGrid) {
  delete incomingGrid.dataset.mainSearchPrefetched;
  delete incomingGrid.dataset.mainSearchPrefetching;
}

initMainSearchFilterBar();

return;
  }

}

      // RESULTS
      if (
        incomingResults &&
        currentResults
      ) {

        currentResults.innerHTML =
  incomingResults.innerHTML;

input.value = rawQuery;

document
  .getElementById('MainSearchPrefetchCache')
  ?.remove();

const incomingGrid =
  document.querySelector('#ShopProductsGrid');

if (incomingGrid) {
  delete incomingGrid.dataset.mainSearchPrefetched;
  delete incomingGrid.dataset.mainSearchPrefetching;
}

initMainSearchFilterBar();

      }

      // EMPTY STATE
      else if (incomingEmpty) {

        if (currentResults) {
          currentResults.innerHTML =
            `<div class="search__no-results-note">
              ${incomingEmpty.innerHTML}
            </div>`;
        }

      }

    } catch (error) {

  if (
    error.name !== 'AbortError'
  ) {
    console.error(error);
  }

} finally {
  if (showLoader) {
    document.body.classList.remove('main-search-loading');
  }
}

  };

  // PREDICTIVE SEARCH
  input.addEventListener(
    'input',
    () => {

      clearTimeout(timeout);

      setTimeout(() => {

  updateResults({ showLoader: false });

}, 20);

    }
  );

    // ENTER KEY
  document.addEventListener(
    'keydown',
    (event) => {

      if (event.key !== 'Enter') {
        return;
      }

      const activeInput =
        document.querySelector(
          '#SearchPageForm input[name="q"]'
        );

      if (
        !activeInput ||
        event.target !== activeInput
      ) {
        return;
      }

      event.preventDefault();

      clearTimeout(timeout);

      updateResults();

    },
    true
  );


   // SEARCH SUBMIT
  form.addEventListener(
    'submit',
    (event) => {

      event.preventDefault();

      clearTimeout(timeout);

      updateResults();

    }
  );

  const loadParams =
    new URLSearchParams(
      window.location.search
    );

  const isHeaderSearchHandoff =
    loadParams.get('handoff') === '1';

  if (isHeaderSearchHandoff) {
    const handoffQuery =
      loadParams.get('q') || '';

    input.value =
      handoffQuery;

    updateResults({ showLoader: false }).then(() => {
      const cleanParams =
        new URLSearchParams(
          window.location.search
        );

      cleanParams.delete('handoff');

      window.history.replaceState(
        {},
        '',
        cleanParams.toString()
          ? `${window.location.pathname}?${cleanParams.toString()}`
          : window.location.pathname
      );
    });

    return;
  }

  const hasProductGrid =
    document.querySelector('#ShopProductsGrid');

  const initialQuery =
    input.value.trim();

  const shouldNormalizeInitialSearch =
    initialQuery.length > 0 &&
    initialQuery !== '*';

  if (shouldNormalizeInitialSearch) {
    updateResults({ showLoader: false });
  } else if (hasProductGrid) {
    initMainSearchFilterBar();
  } else {
    updateResults();
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMainSearchCustom);
} else {
  initMainSearchCustom();
}

document.addEventListener('mystic:route-handoff:complete', initMainSearchCustom);


// SEARCH SUGGESTIONS
document.addEventListener(
  'click',
  (event) => {

    const button =
      event.target.closest(
        '[data-search-suggestion]'
      );

    if (!button) return;

    const input =
      document.querySelector(
        '#SearchPageForm input[name="q"]'
      );

    if (!input) return;

    input.value =
      button.textContent.trim();

    input.dispatchEvent(
      new Event('input', {
        bubbles: true
      })
    );

  }
);

/* CUSTOM FILTER DRAWER ACCORDIONS
   Keeps the Mystic custom filter rows collapsible without replacing
   Aurora's sidebar drawer behavior. */
(() => {
  const rootSelector = '.fc-drawer-filters';
  const groupSelector = '[data-fc-filter-group]';
  const labelSelector = '.filters__label';
  const optionsSelector = '.filters__options';

  const getGroupParts = group => {
    if (!(group instanceof HTMLElement)) return {};

    return {
      label: group.querySelector(labelSelector),
      options: group.querySelector(optionsSelector)
    };
  };

  const setGroupOpen = (group, open) => {
    const { label, options } = getGroupParts(group);

    if (!label || !options) return;

    group.dataset.fcAccordionState = open ? 'open' : 'closed';
    group.classList.toggle('is-open', open);

    label.setAttribute('aria-expanded', String(open));
    options.hidden = !open;
  };

  const initGroup = group => {
    if (!(group instanceof HTMLElement)) return;
    if (group.dataset.fcAccordionReady === 'true') return;

    const { label, options } = getGroupParts(group);

    if (!label || !options) return;

    const filterKey =
      group.getAttribute('data-fc-filter-group') ||
      `filter-${Math.random().toString(36).slice(2, 8)}`;

    if (!options.id) {
      options.id = `fc-filter-panel-${filterKey}-${Math.random()
        .toString(36)
        .slice(2, 8)}`;
    }

    label.setAttribute('role', 'button');
    label.setAttribute('tabindex', '0');
    label.setAttribute('aria-controls', options.id);

    group.classList.add('fc-filter-accordion-ready');
    group.dataset.fcAccordionReady = 'true';

    setGroupOpen(group, group.dataset.fcAccordionState !== 'closed');
  };

  const initAccordions = (scope = document) => {
    if (!(scope instanceof Element || scope instanceof Document)) return;

    scope
      .querySelectorAll(`${rootSelector} ${groupSelector}`)
      .forEach(initGroup);
  };

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;

    const label = event.target.closest(labelSelector);

    if (!label) return;

    const group = label.closest(`${rootSelector} ${groupSelector}`);

    if (!group || group.hidden) return;

    initGroup(group);
    setGroupOpen(group, !group.classList.contains('is-open'));
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (!(event.target instanceof Element)) return;

    const label = event.target.closest(labelSelector);

    if (!label) return;

    const group = label.closest(`${rootSelector} ${groupSelector}`);

    if (!group || group.hidden) return;

    event.preventDefault();

    initGroup(group);
    setGroupOpen(group, !group.classList.contains('is-open'));
  });

  const ready = () => initAccordions();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }

  new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;

        if (node.matches(rootSelector) || node.querySelector(rootSelector)) {
          initAccordions(node);
        }
      });
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
